import { Endpoints } from "../constants/endpoint";

// GET all headings
export const GetAllHeadings = async () => {
    try {
        const res = await fetch(Endpoints.headings);
        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }
        const data = await res.json();
        return data;
    } catch (err) {
        return err.message;
    }
};

// GET heading by ID
export const GetHeadingById = async (id) => {
    try {
        const res = await fetch(`${Endpoints.headings}${id}`);
        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }
        const data = await res.json();
        return data;
    } catch (err) {
        return err.message;
    }
};

// POST create heading
export const CreateHeading = async (payload) => {
    const options = {
        method: "POST",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json;charset=utf-8"
        },
        body: JSON.stringify(payload)
    };

    try {
        const res = await fetch(Endpoints.headings, options);
        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }
        const data = await res.json();
        return data;
    } catch (err) {
        return err.message;
    }
};

// PUT update heading
export const EditHeading = async (id, payload) => {
    const options = {
        method: "PUT",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json;charset=utf-8"
        },
        body: JSON.stringify(payload)
    };

    try {
        const res = await fetch(`${Endpoints.headings}${id}`, options);
        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }
        const data = await res.json();
        return data;
    } catch (err) {
        return err.message;
    }
};

// DELETE heading
export const DeleteHeading = async (id) => {
    const options = {
        method: "DELETE",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json;charset=utf-8"
        }
    };

    try {
        const res = await fetch(`${Endpoints.headings}${id}`, options);
        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }
        const data = await res.json();
        return data;
    } catch (err) {
        return err.message;
    }
};

/**
 * Strict heading edit for undo — propagates failures instead of returning
 * the error message as a string. See the note in services/paragraphs.js.
 */
export const EditHeadingStrict = async (id, payload) => {
    const res = await fetch(Endpoints.headings + id, {
        method: 'PUT',
        headers: { 'Accept': "application/json", 'Content-Type': "application/json;charset=utf-8" },
        body: JSON.stringify(payload)
    });
    if (!res.ok) throw new Error(`HTTP ${res.status} updating heading ${id}`);
    const text = await res.text();
    return text ? JSON.parse(text) : null;
};
